import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import environment from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export default class HistoricalChatService {
    /**
     *
     * @param http
     */
    constructor(private http: HttpClient) {}

    /**
     *
     * @param user
     * @param user.email
     * @param user.name
     * @param user.empID
     * @param q
     * @param limit
     */
    getConversationsByUser(
        user: { email: string; name: string; empID?: number },
        q?: string,
        limit?: number
    ): Observable<any> {
        const params: string[] = [];
        if (limit !== undefined && limit !== null) {
            params.push(`limit=${encodeURIComponent(String(limit))}`);
        }
        if (q) {
            params.push(`q=${encodeURIComponent(q)}`);
        }
        const url = `${environment.apiBaseUrl}/taap-chat/conversation${params.length ? `?${params.join('&')}` : ''}`;
        return this.http.post(url, user).pipe(map((response) => response));
    }

    /**
     *
     * @param conversationId
     * @param historyTitle
     */
    renameConversationById(
        conversationId: string,
        historyTitle: string
    ): Observable<{ success: boolean; message: string }> {
        return this.http
            .patch<{
                success: boolean;
                message: string;
            }>(`${environment.apiBaseUrl}/taap-chat/conversation/${conversationId}/rename`, {
                historyTitle,
            })
            .pipe(map((response) => response));
    }

    /**
     *
     * @param conversationId
     * @param isFavorite
     */
    updateFavoriteChatById(
        conversationId: string,
        isFavorite: boolean
    ): Observable<{ success: boolean; message: string }> {
        return this.http
            .patch<{
                success: boolean;
                message: string;
            }>(`${environment.apiBaseUrl}/taap-chat/conversation/${conversationId}/favorite`, {
                isFavorite,
            })
            .pipe(map((response) => response));
    }

    /**
     *
     * @param conversationId
     */
    deleteChatById(conversationId: string): Observable<{ success: boolean; message: string }> {
        return this.http
            .delete<{
                success: boolean;
                message: string;
            }>(`${environment.apiBaseUrl}/taap-chat/conversation/${conversationId}`)
            .pipe(map((response) => response));
    }

    /**
     *
     * @param conversationId
     */
    getConversationById(conversationId: string): Observable<any> {
        return this.http
            .get<any>(`${environment.apiBaseUrl}/taap-chat/conversation/${conversationId}`)
            .pipe(map((response) => response));
    }
}
